






































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
const log = NSLog("dialog/FindAccount");

import { search as SearchPackage } from "@/dialogs/package";
import accountsApi from "@/services/accounts";
import { Account } from '@/models/account'
import AccountHelpers from '@/models/account';

@Component({
  components: {
    loader,
    SearchPackage
  }
})
export default class EditPackageDialog extends Vue {
  @Prop({ required: true }) public value: boolean = true;
  private loading = false;
  private account: Account | null = null;
  private accountSearchStr = ""; // = load("account_search_string", null);
  private accounts: any = [];

  get displayText() {
    if (this.account) {
      return AccountHelpers.DisplayText(this.account);
    }
    return this.accountSearchStr;
  }

  private async searchAccounts(str?: string) {
    if (str === null) {
      this.accountSearchStr = "";
      this.account = null;
    }
    this.accounts = [];
    if (!str || str.length < 3) {
      return;
    }
    this.loading = true;
    this.searchAccountsDebounce(str);
  }

  // debounced search account
  @debounce(500, { leading: false })
  private async searchAccountsDebounce(str: string) {
    this.account = null;

    this.accountSearchStr = str;
    this.accounts = [];
    this.loading = true;
    try {
      this.accounts = await accountsApi.searchAccounts(str);
    } catch (e) {
      // this.setLastErr(e);
    }
    this.loading = false;
  }
}
